import { render, staticRenderFns } from "./resetPwd.vue?vue&type=template&id=c5940e50&scoped=true"
import script from "./resetPwd.vue?vue&type=script&lang=js"
export * from "./resetPwd.vue?vue&type=script&lang=js"
import style0 from "./resetPwd.vue?vue&type=style&index=0&id=c5940e50&lang=less&scoped=true"
import style1 from "./resetPwd.vue?vue&type=style&index=1&id=c5940e50&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5940e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/saas_fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5940e50')) {
      api.createRecord('c5940e50', component.options)
    } else {
      api.reload('c5940e50', component.options)
    }
    module.hot.accept("./resetPwd.vue?vue&type=template&id=c5940e50&scoped=true", function () {
      api.rerender('c5940e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/resetPwd.vue"
export default component.exports